import { render } from "./PostItem.vue?vue&type=template&id=df2fcf68&scoped=true"
import script from "./PostItem.vue?vue&type=script&lang=js"
export * from "./PostItem.vue?vue&type=script&lang=js"

import "./PostItem.vue?vue&type=style&index=0&id=df2fcf68&scoped=true&lang=css"
import "./PostItem.vue?vue&type=style&index=1&id=df2fcf68&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df2fcf68"]])

export default __exports__